/** @format */

import { DEFAULT_CHECK_IN_DATE, DEFAULT_ORDER_BY } from '../@ducks/filters/constants';
import { TApiBeds } from '../types/apiBeds';
import { NAME_PORTAL_CODE } from '../utils/gatsby/constants';
import { Axios } from '../utils/gatsby/createAxiosInstance';

export const apiSearch = async ({
  language,
  query,
  orderBy = DEFAULT_ORDER_BY,
  checkInDate = DEFAULT_CHECK_IN_DATE,
  positions = [],
  pageIndex = 1,
  districtIds,
  filters = {
    airConditioning: false,
    balcony: false,
    bikeParking: false,
    clothesDryer: false,
    concierge: false,
    internalSide: false,
    lowerFloor: false,
    topFloor: false,
    privateBathroom: false,
    elevator: false,
    colivingBuilding: true,
    singleRoom: true,
    entireStudio: true,
    monthlyPrice: {
      min: 100,
      max: 1500,
    },
  },
  areas = [],
}: {
  language: 'it' | 'en';
  query: string;
  orderBy?: string;
  checkInDate?: string;
  positions?: Array<{ latitude: number; longitude: number }>;
  pageIndex?: number;
  districtIds?: Array<string>;
  filters?: {
    airConditioning: boolean;
    balcony: boolean;
    bikeParking: boolean;
    clothesDryer: boolean;
    concierge: boolean;
    internalSide: boolean;
    lowerFloor: boolean;
    topFloor: boolean;
    privateBathroom: boolean;
    elevator: boolean;
    colivingBuilding: boolean;
    singleRoom: boolean;
    entireStudio: boolean;
    monthlyPrice: {
      min: number;
      max: number;
    };
  };
  areas?: Array<{ max_latitude: number; min_latitude: number; max_longitude: number; min_longitude: number }>;
}): Promise<TApiBeds> => {
  const locale = language === 'it' ? 'it-it' : 'en-us';
  const URL = `/Beds/${NAME_PORTAL_CODE}?language=${locale}`;
  try {
    const response = await Axios.post(URL, {
      query,
      orderBy,
      checkInDate,
      positions,
      pageIndex,
      districtIds,
      filters,
      areas,
    });
    return response.data;
  } catch (error) {
    console.log(error);
    throw new Error(`ATTENTION: Error on API ${URL}`);
  }
};
